import { render, staticRenderFns } from "./AddPropertyCompany.vue?vue&type=template&id=74693106"
import script from "./AddPropertyCompany.vue?vue&type=script&lang=js"
export * from "./AddPropertyCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports